"use strict";

import axios from 'axios';
import { getXdbTrackedActivityConverterForSitecore } from "./xdbEventConverter";
var XdbDispatcher = /** @class */function () {
  function XdbDispatcher(settings) {
    this.requiresBrowser = true;
    this.type = "xdb";
    this.endpoints = settings === null || settings === void 0 ? void 0 : settings.endpoints;
    this.httpHeaders = settings === null || settings === void 0 ? void 0 : settings.httpHeaders;
    this.queryStringParameters = settings === null || settings === void 0 ? void 0 : settings.queryStringParameters;
  }
  XdbDispatcher.prototype.dispatchActivity = function (results, settings, logger) {
    var _this = this;
    var _a;
    var converter = getXdbTrackedActivityConverterForSitecore();
    //
    //If the activities were tracked as events, dispatch them.
    if (settings.event) {
      logger.info("xDB dispatcher - Activity was dispatched in event mode.", {
        activities: results.visitActivities,
        settings: settings
      });
      var endpoint_1 = (_a = this.endpoints) === null || _a === void 0 ? void 0 : _a.event;
      if (!endpoint_1) {
        logger.error("xDB dispatcher - No event endpoint is specified, so unable to dispatch activities.", {
          endpoints: this.endpoints,
          activities: results.visitActivities
        });
        return;
      }
      results.visitActivities.forEach(function (activity) {
        var pageEvent = converter.convert(activity);
        if (!pageEvent) {
          logger.error("xDB dispatcher - Activity was not converted into a page event, so unable to dispatch activity.", {
            activity: activity
          });
          return;
        }
        dispatchPageEvent(pageEvent, endpoint_1, _this.httpHeaders, _this.queryStringParameters, settings, logger);
      });
      return;
    }
    //
    //If the activities were tracked as a result of a page view, 
    //only dispatch the page view events. When the Sitecore 
    //tracking process runs, those activities will be captured.
    var pageViews = results.visitActivities.filter(function (activity) {
      return activity.type === "page view";
    });
    pageViews.forEach(function (pageView) {
      var _a;
      var url = (_a = pageView.data) === null || _a === void 0 ? void 0 : _a.url;
      if (!url) {
        logger.error("xDB dispatcher - No url is set on the page view activity, so unable to dispatch.", {
          activity: pageView,
          settings: settings
        });
        return;
      }
      dispatchPageView(url, _this.httpHeaders, _this.queryStringParameters, settings, logger);
    });
  };
  return XdbDispatcher;
}();
export { XdbDispatcher };
function appendQueryStringParameters(url, queryStringParameters) {
  if (!queryStringParameters) return url;
  var url2 = new URL(url);
  var search2 = Object.keys(queryStringParameters).map(function (key) {
    var value = queryStringParameters[key];
    return "".concat(key, "=").concat(value);
  }).join('&');
  var url3 = url2.href;
  if (!url2.search) {
    url3 += "?";
  }
  url3 += search2;
  return url3;
}
function dispatchPageView(url, httpHeaders, queryStringParameters, settings, logger) {
  if (queryStringParameters) {
    url = appendQueryStringParameters(url, queryStringParameters);
  }
  if (!httpHeaders) {
    httpHeaders = {};
  }
  httpHeaders["X-Referer"] = document.referrer;
  var config = {
    method: "GET",
    headers: httpHeaders,
    withCredentials: true
  };
  var data = {
    url: url,
    config: config
  };
  var onBeforeDispatchData = settings.onBeforeDispatchData;
  if (onBeforeDispatchData) {
    data = onBeforeDispatchData("xdb", data, logger);
    if (!data) {
      logger.debug("xDB dispatcher dispatcher - Cancelling dispatch because no event data is available.", {
        originalData: {
          url: url,
          config: config
        }
      });
      return;
    }
  }
  axios(data.url, data.config).then(function (response) {
    return logger.debug("xDB dispatcher - Response received after sending request to Sitecore CD instance.", {
      response: response,
      requestModifications: {
        httpHeaders: httpHeaders,
        queryStringParameters: queryStringParameters,
        settings: settings
      }
    });
  }).catch(function (err) {
    return logger.error("xDB dispatcher - Error sending request to Sitecore CD instance.", {
      url: url,
      requestModifications: {
        httpHeaders: httpHeaders,
        queryStringParameters: queryStringParameters
      },
      err: err,
      settings: settings
    });
  });
}
function dispatchPageEvent(pageEvent, endpoint, httpHeaders, queryStringParameters, settings, logger) {
  var url = endpoint.url;
  if (queryStringParameters) {
    url = appendQueryStringParameters(url, queryStringParameters);
  }
  var config = {
    data: pageEvent,
    headers: httpHeaders,
    method: endpoint.method,
    withCredentials: true
  };
  var data = {
    url: url,
    config: config
  };
  var onBeforeDispatchData = settings.onBeforeDispatchData;
  if (onBeforeDispatchData) {
    data = onBeforeDispatchData("xdb", data, logger);
    if (!data) {
      logger.debug("xDB dispatcher dispatcher - Cancelling dispatch because no event data is available.", {
        originalData: {
          url: url,
          config: config
        }
      });
      return;
    }
  }
  logger.debug("xDB dispatcher - Sending request to Uniform endpoint.", {
    url: url,
    method: endpoint.method,
    pageEvent: pageEvent
  });
  axios(data.url, data.config).then(function (response) {
    return logger.debug("xDB dispatcher - Response received after sending request to Uniform endpoint.", {
      response: response,
      endpoint: endpoint,
      requestModifications: {
        httpHeaders: httpHeaders,
        queryStringParameters: queryStringParameters,
        settings: settings
      }
    });
  }).catch(function (err) {
    return logger.error("xDB dispatcher - Error sending request to Uniform endpoint.", {
      url: url,
      endpoint: endpoint,
      requestModifications: {
        httpHeaders: httpHeaders,
        queryStringParameters: queryStringParameters
      },
      err: err,
      settings: settings
    });
  });
}